import { useEffect } from 'react'
import './PrivacyPolicy.css'

interface PrivacyPolicyProps {
  open: boolean
  onClose: () => void
}

export default function PrivacyPolicy({ open, onClose }: PrivacyPolicyProps) {
  useEffect(() => {
    if (!open) return
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', handleKey)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      className="privacy-overlay"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="privacy-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="privacy-close"
          onClick={onClose}
          aria-label="Stäng integritetspolicy"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h2 id="privacy-title" className="privacy-title">Integritetspolicy</h2>

        <div className="privacy-body">
          <p>
            Catarina Malmberg värnar om din personliga integritet. Här beskriver jag hur
            personuppgifter hanteras när du kontaktar mig eller använder webbplatsen.
          </p>

          <h3>Personuppgiftsansvarig</h3>
          <p>
            Catarina Malmberg, Spångatan 20 A, 211 53 Malmö.<br />
            Tel: 0733-788272 · E-post:{' '}
            <a href="mailto:mail@catarinamalmberg.se">mail@catarinamalmberg.se</a>
          </p>

          <h3>Vilka uppgifter samlas in?</h3>
          <p>
            När du kontaktar mig via kontaktformuläret, telefon eller mejl lämnar du uppgifter
            som namn, kontaktuppgifter och det du själv väljer att berätta om din situation.
            Uppgifterna används endast för att kunna besvara din förfrågan och, om du blir klient,
            för att bedriva terapi. Allt du berättar hanteras konfidentiellt enligt GDPR och
            Patientdatalagen.
          </p>

          <h3>Cookies</h3>
          <p>
            Webbplatsen använder inga egna cookies och ingen besöksstatistik samlas in.
            Inbäddat innehåll från tredje part (karta från Google Maps och typsnitt från Google Fonts)
            kan sätta egna cookies enligt respektive leverantörs villkor.
          </p>

          <h3>Lagring och dina rättigheter</h3>
          <p>
            Uppgifter sparas inte längre än nödvändigt för ändamålet. Du har rätt att begära
            information om vilka uppgifter som finns om dig, att få felaktiga uppgifter rättade
            samt att få uppgifter raderade. Kontakta mig på uppgifterna ovan för sådana ärenden.
            Du har också rätt att lämna klagomål till Integritetsskyddsmyndigheten (IMY).
          </p>
        </div>
      </div>
    </div>
  )
}
